import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Header from '../../common/Header';
import PageContentPanel from '../panels/PageContentPanel';
import { DashboardTimelineType, OwnerType } from '../../../constants/ComponentTypes';

const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    overflowY: 'auto',
  },
});

class LeadNote extends React.Component {
  initialState = {
    ownerType: OwnerType.OWN.value,
  }
  constructor(props) {
    super(props);
    const ownerType = props.location.state && props.location.state.ownerType ? props.location.state.ownerType : OwnerType.OWN.value;
    this.state = { ...this.initialState, ...{ ownerType: ownerType } };
  }

  componentDidMount() {
    this.props.getUserInfo();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Header
          title="ダッシュボード"
          secondaryTitle={DashboardTimelineType.LEAD_NOTE.text}
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() => this.props.goTo('/order-dashboard', {
            ownerType: this.state.ownerType
          })}
        />
        <PageContentPanel
          type={DashboardTimelineType.LEAD_NOTE.value}
          items={this.props.list}
          goTo={this.props.goTo}
          isLoading={this.props.isLoading}
          pageInfo={this.props.pageInfo}
          ownerType={this.state.ownerType}
          getStatus={this.props.getPersonLeadNoteStatus}
        />
      </div>
    )
  }
}

LeadNote.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  pageInfo: PropTypes.object,
  getPersonLeadNoteStatus: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  user: PropTypes.object,
  list: PropTypes.array,
  location: PropTypes.object,
};

export default withStyles(styles)(LeadNote);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/pages/LeadNote.jsx